import React from 'react';
import { useIntl } from 'react-intl';

import { ActionDialogWizard, DialogWizardScreen } from '@futrli/ui-components/components/dialog-wizard';
import { OrganisationListItem } from '@futrli-sdk/workspaces';

import { getBillByStatusLabel } from '../../utils/billing-status';

interface ResubscribeSfaOrgDialogProps {
  isOpen: boolean;
  onClose: () => void;
  organisation: OrganisationListItem;
}

export const ResubscribeSfaOrgDialog = ({ isOpen, onClose, organisation }: ResubscribeSfaOrgDialogProps) => {
  const intl = useIntl();

  return (
    <ActionDialogWizard
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      screen={DialogWizardScreen.CONFIRM}
      title={getBillByStatusLabel(organisation.billed_by_status, intl)}
      confirmDescription={intl.formatMessage({
        id: 'organisations.org_canceled_sfa_billed_by',
        defaultMessage:
          'To re-enable this organisation, you will need to visit the sage client management area, add a new client matching this organisation name and then follow the migration process to move this cancelled organisation to be managed via client management.'
      })}
      confirmButtonText={intl.formatMessage({
        id: 'common.ok',
        defaultMessage: 'OK'
      })}
      cancelButtonText={intl.formatMessage({
        id: 'common.cancel',
        defaultMessage: 'Cancel'
      })}
      dataTestId="resubscribe-sfa-org-dialog"
    />
  );
};
